import Cookies from 'universal-cookie'

const COOKIES_TO_BE_PROXIED = [process.env.NEXT_PUBLIC_BH_VARY]
let fetchPatched = false

/**
 * This function is used to proxy cookies to headers during client-side navigation.
 * Next.js uses /_next/data path to fetch data from server during client-side navigation.
 * Bluheadless saves cookies in /{storeCode} path making it impossible to forward cookies to server.
 * This function solves this problem.
 * Instead of forward cookies (that is not allowed), it forwards them to headers.
 */

const nextDataFetchCookiesProxy = () => {
	if (globalThis.fetch && !fetchPatched) {
		const originalFetch = globalThis.fetch

		globalThis.fetch = (resource, options, ...args) => {
			const cookies = new Cookies()
			const isNextDataFetch = /^\/_next\/data/.test(resource)

			const bhOptions = { ...options }

			if (isNextDataFetch) {
				const cookieHeaders = COOKIES_TO_BE_PROXIED.reduce(
					(acc, cookie) => ({ ...acc, [cookie]: cookies.get(cookie) }),
					{}
				)
				bhOptions.headers = { ...options.headers, ...cookieHeaders }
			}

			return originalFetch(resource, bhOptions, ...args)
		}
		fetchPatched = true
	}
}

export default nextDataFetchCookiesProxy
